import { gql } from '@apollo/client';
import CLASSROOM_FRAGMENT from 'graph/fragments/classroom';
import CLASSROOM_LICENSE_USAGE_FRAGMENT from 'graph/fragments/classroom-license-usage';
import CLASSROOM_STATS_FRAGMENT from 'graph/fragments/classroom-stats';

const GET_MY_ORGANIZATION_NAMES_CLASSROOMS_AND_MASTER_CODES = gql`
  query getMyOrganizationNamesClassroomsAndMasterCodes($userId: Int!) {
    user(where: { id: $userId }) {
      organizationAssociations {
        organization {
          id
          name
        }
      }
    }
    classrooms(
      where: { archived: false }
      whereUser: { id: [$userId] }
      orderBy: { field: NAME, direction: ASC }
    ) {
      ...BaseClassroom
      licenseUsage {
        ...BaseClassroomLicenseUsage
      }
      stats {
        ...BaseClassroomStats
      }
    }
    mastercodes(where: { expired: false }) {
      id
      status
      orderItems {
        id
        licenseType
        product {
          id
          code
        }
      }
    }
  }
  ${CLASSROOM_FRAGMENT}
  ${CLASSROOM_LICENSE_USAGE_FRAGMENT}
  ${CLASSROOM_STATS_FRAGMENT}
`;

export default GET_MY_ORGANIZATION_NAMES_CLASSROOMS_AND_MASTER_CODES;
